import { ceil, isEmpty } from "lodash";
import { Base, BaseIdOnly } from "../base";
import { DEFAULT_CURRENCY } from "../currency";
import { DEFAULT_LANGUAGE } from "../language";
import { Discount } from "./discount";
import { PAYMENT_AMOUNT_PRECISION } from "./payment";
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["INITIAL"] = "initial";
    TransactionStatus["SUBMITTED"] = "submitted";
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["PROCESSING"] = "processing";
    TransactionStatus["SUCCEEDED"] = "succeeded";
    TransactionStatus["REFUNDED"] = "refunded";
    TransactionStatus["FAILED"] = "failed";
})(TransactionStatus || (TransactionStatus = {}));
export class TransactionItem extends BaseIdOnly {
    constructor(params) {
        super(params);
        this.productId = params.productId;
        this.name = params.name || "";
        this.price = params.price;
        this.contact = params.contact;
        if (params.priceId)
            this.priceId = params.priceId;
        if (params.extraInfo && !isEmpty(params.extraInfo))
            this.extraInfo = params.extraInfo;
    }
}
export class Transaction extends Base {
    constructor(params) {
        super(params);
        this.userId = params.userId;
        this.eventId = params.eventId;
        this.contact = params.contact || {};
        this.status = params.status || TransactionStatus.INITIAL;
        this.language = params.language || DEFAULT_LANGUAGE;
        this.currency = params.currency || DEFAULT_CURRENCY;
        this.items = (params.items || []).map((item) => new TransactionItem(item));
        this.webhookEvents = params.webhookEvents || [];
        this.refIds = params.refIds || [];
        this.fee = params.fee || 0;
        this.amount = params.amount || this.originalAmount;
        this.finalAmount = ceil(this.amount + this.transactionFee, PAYMENT_AMOUNT_PRECISION);
        if (params.paymentMethod)
            this.paymentMethod = params.paymentMethod;
        if (params.error)
            this.error = params.error;
        if (params.discount) {
            this.discount = new Discount(params.discount);
        }
        this.calculateFinalAmount();
    }
    get originalAmount() {
        return ceil(this.items.reduce((acc, cur) => (acc += cur.price), 0), PAYMENT_AMOUNT_PRECISION);
    }
    get transactionFee() {
        if (!this.fee)
            return 0;
        return ceil(this.amount * this.fee, PAYMENT_AMOUNT_PRECISION);
    }
    get discountAmount() {
        if (!this.discount)
            return 0;
        return Math.min(this.items.reduce((acc, cur) => (acc +=
            this.discount &&
                (this.discount.productId
                    ? cur.productId == this.discount.productId
                    : true)
                ? this.discount.calculateDiscount(cur.price)
                : 0), 0), this.originalAmount);
    }
    // apply discount to each of the items
    applyDiscount(discount) {
        if (!(discount === null || discount === void 0 ? void 0 : discount.code) ||
            discount.value == undefined ||
            discount.value == null)
            return this;
        if (discount.productId &&
            !this.items.some((item) => item.productId == discount.productId))
            return this;
        this.discount = discount;
        this.amount = ceil(Math.max(this.originalAmount - this.discountAmount, 0), PAYMENT_AMOUNT_PRECISION);
        this.finalAmount = ceil(this.amount + this.transactionFee, PAYMENT_AMOUNT_PRECISION);
        return this;
    }
    calculateFinalAmount() {
        this.amount = this.originalAmount;
        this.finalAmount = ceil(this.amount + this.transactionFee, PAYMENT_AMOUNT_PRECISION);
        if (this.discount)
            this.applyDiscount(this.discount);
        return this;
    }
    update() {
        this.updatedAt = new Date().valueOf();
        this.calculateFinalAmount();
        return this;
    }
}
